import { render, staticRenderFns } from "./socialMenu.vue?vue&type=template&id=18e0a7de&scoped=true"
import script from "./socialMenu.vue?vue&type=script&lang=js"
export * from "./socialMenu.vue?vue&type=script&lang=js"
import style0 from "./socialMenu.vue?vue&type=style&index=0&id=18e0a7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e0a7de",
  null
  
)

export default component.exports